<script>
	import Router, { link, push, location as browserLocation} from "svelte-spa-router";
	import { replace } from "svelte-spa-router";
	import { routes } from "./routes.js";
	import { setContext } from "svelte";
	import { User, Language } from "@Store";
	import jwt_decode from 'jwt-decode';
	import Logo from "@assets/logo.png";
	import translations from "./utils/translations.js";

	const translationMap = {};
	translations.forEach(item => {
		if (item.eng && item.fr) translationMap[item.eng] = item.fr;
	});
	$: t = (text) => ($Language === 'fr' && translationMap[text]) ? translationMap[text] : text;
	let token = localStorage.getItem("insurecert_token");
	$: if(token){
		$User = jwt_decode(token);
	}

	export let program;

	setContext("PROGRAM",{program})

	let showRestartModal = false;

	function openRestartModal() {
		showRestartModal = true;
	}

	function closeRestartModal() {
		showRestartModal = false;
	}

    function confirmRestart() {
        localStorage.removeItem('policyID')
        replace(`/`);
        setTimeout(()=>{
        	window.location.reload();
        },100)
    }

	function logout() {
		localStorage.removeItem('insurecert_token')
		window.location.reload()
	}

	let showResourcesDropdown = false;

	function toggleResourcesDropdown() {
		showResourcesDropdown = !showResourcesDropdown;
	}

	function handleClickOutside(e) {
		if (showResourcesDropdown) {
			showResourcesDropdown = false;
		}
	}

</script>

<svelte:window on:click={handleClickOutside} />

<header class="app-header">
	<div class="header-container">
		<div class="brand">
			<a href="https://www.ccpaonline.ca/en-US/" target="_blank" rel="noopener noreferrer" class="brand-link">
				<img src="{Logo}" alt="CAND Insurance" class="brand-logo" />
				<span class="brand-name">{$Language === 'fr' ? `Programme d\'assurance commerciale sponsorisé par l'APCC` : 'CCPA Sponsored Business Insurance Program'}</span>
			</a>
		</div>
		
		<nav class="nav-actions">
			<button class="header-button secondary" on:click={openRestartModal}>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
					<path d="M13.65 2.35A7.5 7.5 0 1 0 8 15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
					<path d="M13 2.5V6h-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				{t("Restart")}
			</button>

			{#if $User}
				<button class="header-button primary" on:click={() => push('/dashboard')}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
						<rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
						<rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
						<rect x="9" y="9" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.5"/>
					</svg>
					{t("Dashboard")}
				</button>
				<button class="header-button secondary" on:click={() => logout()}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M10 2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2M6 12l-4-4m0 0l4-4m-4 4h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					{t("Logout")}
				</button>
			{:else}
				<button class="header-button primary" on:click={() => push('/dashboard')}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M11 7v2a3 3 0 0 1-6 0V7a3 3 0 0 1 6 0Z" stroke="currentColor" stroke-width="1.5"/>
						<path d="M8 12v2m-3 0h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
					</svg>
					{t("Login")}
				</button>
			{/if}

			<!-- NEW RESOURCES DROPDOWN -->
			<div class="resources-dropdown">
				<button class="header-button secondary" on:click|stopPropagation={toggleResourcesDropdown}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
						<path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
						<circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/>
					</svg>
					{$Language === 'en' ? 'Resources' : 'Ressources'}
					<svg class="dropdown-chevron" class:open={showResourcesDropdown} width="12" height="12" viewBox="0 0 12 12" fill="none">
						<path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</button>
				
				{#if showResourcesDropdown}
					<div class="dropdown-menu" on:click|stopPropagation>
						<a href="https://ccpa.ipmgainsurance.com/policy-wording/" target="_blank" rel="noopener noreferrer" class="dropdown-item">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path d="M9 2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6m-4-4l4 4m-4-4v4h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span>{$Language === 'en' ? 'Policy Wordings' : 'Libellés de la police'}</span>
						</a>

						<a href="https://ccpa.ipmgainsurance.com/faqs/" target="_blank" rel="noopener noreferrer" class="dropdown-item">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
								<circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/>
								<path d="M8 11h.01M8 8a1 1 0 0 1 1-1c.5 0 1-.5 1-1s-.5-1-1-1-1 .5-1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
							</svg>
							<span>{$Language === 'en' ? 'FAQs' : 'FAQ'}</span>
						</a>

						<a href="https://ccpa.ipmgainsurance.com/glossary/" target="_blank" rel="noopener noreferrer" class="dropdown-item">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path d="M4 2h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" stroke="currentColor" stroke-width="1.5"/>
								<path d="M5 5h6M5 8h6M5 11h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
							</svg>
							<span>{$Language === 'en' ? 'Glossary' : 'Glossaire'}</span>
						</a>

						<a href="https://ccpa.ipmgainsurance.com/contact-us/" target="_blank" rel="noopener noreferrer" class="dropdown-item">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
								<path d="M14 11.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
								<path d="M8 8l6-6M10 2h4v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<span>{$Language === 'en' ? 'Contact Us' : 'Contactez-nous'}</span>
						</a>
					</div>
				{/if}
			</div>

			<button class="lang-toggle" on:click={() => $Language = $Language === 'en' ? 'fr' : 'en'}>
				<svg class="globe-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
					<circle cx="12" cy="12" r="10"/>
					<path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
				</svg>
				<span class="lang-text">{$Language === 'en' ? 'FR' : 'EN'}</span>
			</button>
		</nav>
	</div>
</header>

<main class="app-main">
	<Router {routes}/>
</main>

<!-- Restart Confirmation Modal -->
{#if showRestartModal}
	<div class="modal-overlay" on:click={closeRestartModal}>
		<div class="modal-content" on:click|stopPropagation>
			<div class="modal-icon">
				<svg width="48" height="48" viewBox="0 0 48 48" fill="none">
					<circle cx="24" cy="24" r="20" stroke="#0071e3" stroke-width="2"/>
					<path d="M24 16v12M24 32h.01" stroke="#0071e3" stroke-width="2.5" stroke-linecap="round"/>
				</svg>
			</div>
			
			<h2 class="modal-title">{t("Start Over?")}</h2>
			<p class="modal-message">
				{t("This will clear your current application and start a new one. All progress will be lost.")}
			</p>

			<div class="modal-actions">
				<button class="modal-button cancel" on:click={closeRestartModal}>
					{t("Cancel")}
				</button>
				<button class="modal-button confirm" on:click={confirmRestart}>
					{t("Start Over")}
				</button>
			</div>
		</div>
	</div>
{/if}

<style>
	:global(html, body) {
		margin: 0;
		padding: 0;
		height: 100%;
		overflow: auto;
	}

	:global(body) {
		background: #f5f5f7;
		/* --base-green: #316832;
		--base-green-light: #428442;
		--base-green-lightest: #acd4ac;
		--base-blue: #437c90;
		--base-blue-light: #6996a6;
		--base-blue-lightest: #8eb0bc;
		--gold: #e3a125;
		--red: #ac3931;
		--dark: #14262b;
		--light: #f9f2e8; */
		--base-green: #4CBEA0;           /* PANTONE 3395 CP - Teal */
		--base-green-light: #6DCDB3;     /* Lighter teal */
		--base-green-lightest: #9EDDC9;  /* Lightest teal */
		--base-blue: #293B5E;            /* PANTONE 533 CP 80% - Dark Blue */
		--base-blue-light: #3A5180;      /* Lighter dark blue */
		--base-blue-lightest: #5B7AA8;   /* Lightest dark blue */
		--gold: #F05C22;                 /* PANTONE 1665 CP - Orange */
		--red: #DA1A32;                  /* PANTONE 186 CP - Red */
		--magenta: #B01C87;              /* PANTONE 241 CP - Magenta (new accent) */
		--dark: #293B5E;                 /* PANTONE 533 CP 80% for dark text */
		--light: #f9f2e8;                /* Keep existing light background */
	}

	.app-header {
		position: sticky;
		top: 0;
		background: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(20px) saturate(180%);
		-webkit-backdrop-filter: blur(20px) saturate(180%);
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
		z-index: 1000;
		width: 100%;
	}

	.header-container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 1rem 2rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.brand {
		display: flex;
		align-items: center;
		gap: 0.75rem;
	}

	.brand-logo {
		height: 50px;
		width: auto;
		object-fit: contain;
	}

	.brand-name {
		font-size: 1.25rem;
		font-weight: 600;
		color: #1d1d1f;
		letter-spacing: -0.02em;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.brand-link {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		text-decoration: none;
		transition: opacity 0.2s ease;
	}

	.brand-link:hover {
		opacity: 0.7;
	}

	.brand-link:hover .brand-logo {
		transform: scale(1.02);
		transition: transform 0.2s ease;
	}

	.nav-actions {
		display: flex;
		gap: 0.75rem;
		align-items: center;
	}

	.header-button {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		padding: 0.5rem 1rem;
		font-size: 0.9375rem;
		font-weight: 500;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.header-button.primary {
		background: var(--base-green);
		color: white;
	}

	.header-button.primary:hover {
		background: var(--base-green-light);
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 113, 227, 0.3);
	}

	.header-button.secondary {
		background: transparent;
		color: #1d1d1f;
	}

	.header-button.secondary:hover {
		background: rgba(0, 0, 0, 0.05);
	}

	.header-button:active {
		transform: translateY(0);
	}

	.lang-toggle {
		display: flex;
		align-items: center;
		gap: 0.375rem;
		padding: 0.5rem 0.75rem;
		background: transparent;
		border: 1.5px solid #d2d2d7;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.lang-toggle:hover {
		background: rgba(0, 0, 0, 0.05);
		border-color: #86868b;
	}

	.globe-icon {
		width: 18px;
		height: 18px;
		color: #1d1d1f;
	}

	.lang-text {
		font-size: 0.875rem;
		font-weight: 600;
		color: #1d1d1f;
		letter-spacing: 0.02em;
	}

	.app-main {
		padding-top: 1rem;
	}

	.resources-dropdown {
		position: relative;
	}

	.dropdown-chevron {
		transition: transform 0.2s ease;
	}

	.dropdown-chevron.open {
		transform: rotate(180deg);
	}

	.dropdown-menu {
		position: absolute;
		top: calc(100% + 0.5rem);
		right: 0;
		background: white;
		border: 1px solid rgba(0, 0, 0, 0.1);
		border-radius: 12px;
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
		min-width: 200px;
		padding: 0.5rem;
		z-index: 1001;
		animation: fadeIn 0.15s ease;
	}

	.dropdown-item {
		display: flex;
		align-items: center;
		gap: 0.625rem;
		padding: 0.625rem 0.75rem;
		border-radius: 8px;
		text-decoration: none;
		color: #1d1d1f;
		font-size: 0.9375rem;
		font-weight: 500;
		transition: background 0.15s ease;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.dropdown-item:hover {
		background: rgba(0, 0, 0, 0.05);
	}

	.dropdown-item svg {
		flex-shrink: 0;
		color: #6b7280;
	}

	/* Modal Styles */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.4);
		backdrop-filter: blur(4px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 2000;
		animation: fadeIn 0.2s ease;
	}

	@keyframes fadeIn {
		from { opacity: 0; }
		to { opacity: 1; }
	}

	.modal-content {
		background: white;
		border-radius: 20px;
		padding: 2rem;
		max-width: 400px;
		width: 90%;
		text-align: center;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
		animation: slideUp 0.3s ease;
	}

	@keyframes slideUp {
		from {
			opacity: 0;
			transform: translateY(20px) scale(0.95);
		}
		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	.modal-icon {
		margin-bottom: 1.5rem;
	}

	.modal-title {
		font-size: 1.5rem;
		font-weight: 600;
		color: #1d1d1f;
		margin: 0 0 1rem 0;
		letter-spacing: -0.02em;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.modal-message {
		font-size: 1rem;
		color: #86868b;
		line-height: 1.5;
		margin: 0 0 2rem 0;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.modal-actions {
		display: flex;
		gap: 0.75rem;
		justify-content: center;
	}

	.modal-button {
		flex: 1;
		padding: 0.875rem 1.5rem;
		font-size: 1rem;
		font-weight: 500;
		border: none;
		border-radius: 12px;
		cursor: pointer;
		transition: all 0.2s ease;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
	}

	.modal-button.cancel {
		background: #f5f5f7;
		color: #1d1d1f;
	}

	.modal-button.cancel:hover {
		background: #e8e8ed;
	}

	.modal-button.confirm {
		background: #ff3b30;
		color: white;
	}

	.modal-button.confirm:hover {
		background: #ff453a;
		transform: translateY(-1px);
		box-shadow: 0 4px 12px rgba(255, 59, 48, 0.3);
	}

	.modal-button:active {
		transform: translateY(0);
	}

	@media (max-width: 768px) {
		.header-container {
			padding: 0.75rem 1rem;
		}

		.brand-logo {
			height: 32px;
		}

		.brand-name {
			font-size: 1.125rem;
		}

		.nav-actions {
			gap: 0.5rem;
		}

		.header-button {
			padding: 0.5rem 0.75rem;
			font-size: 0.875rem;
		}

		.lang-toggle {
			padding: 0.4rem 0.6rem;
		}

		.globe-icon {
			width: 16px;
			height: 16px;
		}

		.lang-text {
			font-size: 0.8125rem;
		}

		.modal-content {
			padding: 1.5rem;
		}

		.modal-actions {
			flex-direction: column;
		}

		.modal-button {
			width: 100%;
		}
	}
	:global(.questions-wrapper) {
        width: 100%;
        max-width: 500px;
    }

	:global(.page-container) {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    :global(.section-container) {
        width: 100%;
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border: 2px solid #e9ecef;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 2rem 1.5rem;
        margin-top: 2rem;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    }

    :global(.section-header) {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding-bottom: 1.5rem;
        border-bottom: 2px solid #e9ecef;
    }

    :global(.section-icon) {
        font-size: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        background: linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%);
        border-radius: 16px;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(255, 193, 7, 0.15);
    }

    :global(.section-header h1) {
        font-size: 1.375rem;
        font-weight: 600;
        color: #1d1d1f;
        margin: 0;
        line-height: 1.3;
        letter-spacing: -0.01em;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    :global(.sub-questions) {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        margin-top: 1.5rem;
    }

    :global(.sub-question) {
        position: relative;
    }

    @media (max-width: 768px) {
        :global(.section-container) {
            padding: 1.5rem 1rem;
            border-radius: 16px;
        }

        :global(.section-header) {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
        }

        :global(.section-header h1) {
            font-size: 1.25rem;
        }

        :global(.section-icon) {
            width: 48px;
            height: 48px;
            font-size: 1.75rem;
        }

        :global(.sub-question) {
            padding-left: 1rem;
        }

        :global(.sub-question::before) {
            width: 3px;
        }
    }
</style>